import { DATAGRID_COMMON_STYLE } from '@commons/utils/dataGrid';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Card = styled.div`
  width: 100%;
  background: ${(props) => props.theme.colors.greys.lightest};
  box-shadow: ${(props) => props.theme.shadows.short};
  border-radius: ${(props) => props.theme.borders.radius.weak};
`;

export const VariantsTabsBar = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: 24px;
  margin-top: -16px;
`;

export const VariantTab = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 32px;
  color: ${(props) => props.theme.colors.greys.darker};
  font: ${(props) => props.theme.fonts.textMiddleNormal};
  border-bottom: 2px solid transparent;

  ${(props) =>
    props.$selected
      ? css`
          color: ${props.theme.colors.greys.darkest};
          border-bottom-color: ${props.theme.colors.brand.primary};
          cursor: default;
        `
      : css`
          &:hover {
            color: ${props.theme.colors.greys.darkest};
            cursor: pointer;
          }
        `};
`;

export const DataGridWrapper = styled.div`
  overflow: hidden;
  border-bottom-left-radius: ${(props) => props.theme.borders.radius.weak};
  border-bottom-right-radius: ${(props) => props.theme.borders.radius.weak};
`;

export const ContainerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const ContainerContent = styled.div`
  width: 100%;
`;

export const TitleHeader = styled.div`
  color: ${(props) => props.theme.colors?.greys.darkest};
  font: ${(props) => props.theme.fonts.h2};
  width: fit-content;
  padding-right: 14px;
  text-align: left;
`;

export const InlineContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  > div {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
    margin-left: 0px;

    > div {
      height: 50px;
      display: flex;
    }
  }
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    transition: filter 0.15s ease-in-out;
  }

  &:hover img {
    filter: invert(62%) sepia(33%) saturate(3767%) hue-rotate(107deg) brightness(100%)
      contrast(100%);
  }
`;

export const ROW_HEIGHT = 56;
const COLUMN_HEADER_HEIGHT = 56;
const MAX_VISIBLE_ROWS = 10;

// Define max height for the datagrid before triggering verital scroll. These values are arbitrary and can be adjusted.
const DATAGRID_MAX_HEIGHT = COLUMN_HEADER_HEIGHT + MAX_VISIBLE_ROWS * ROW_HEIGHT;

export const getDatagridSX = (theme) => ({
  ...DATAGRID_COMMON_STYLE,
  marginBottom: 0,
  border: 'none',
  height: 'auto',
  maxHeight: `${DATAGRID_MAX_HEIGHT}px`,
  '& .MuiDataGrid-columnHeaders': {
    borderBottom: `1px solid ${theme.colors.greys.light}`,
    borderTop: `1px solid ${theme.colors.greys.light}`,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: '14px',
    fontWeight: 600,
  },
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${theme.colors.greys.light}`,
    fontSize: '14px',
  },
  '& .MuiDataGrid-pinnedColumns': {
    boxShadow: 'none !important',
    borderLeft: 'none !important',
  },
  '& .MuiDataGrid-pinnedColumnHeaders': {
    boxShadow: 'none !important',
    borderLeft: 'none !important',
  },
  '& .MuiDataGrid-pinnedColumnHeaders--right': {
    boxShadow: 'none !important',
    borderLeft: 'none !important',
  },
  '& .MuiDataGrid-columnHeader--withRightBorder': {
    borderRight: 'none !important',
  },
  '& .MuiDataGrid-cell--withRightBorder': {
    borderRight: 'none !important',
  },
});
